export default {
    error_title: 'Error!',
    warning_title: 'Warning!',
    wrong_input_title: 'Invalid inputs!',
    action_not_done: 'Failed, conflicting request!',
    error_asaas_payment: {
        invalid_value: 'The minimum value for charges via Credit Card is R$5.00.',
        invalid_billingType: 'The payment method is not allowed for subscriptions.',
    },
    without_connection: {
        title: 'Unable to Connect to the Server',
        message: 'Make sure you are connected to the internet.',
    },
    unexpected: {
        title: 'Something went wrong!',
        message: 'Sorry, something went wrong, please try again.'
    },
    maintenance: {
        title: 'Under Maintenance!',
        message: 'Sorry, we are currently under maintenance, try again after a few minutes.'
    },
    recaptcha: {
        alert_title: 'Problem with reCaptcha',
        alert_body: "Our website is protected by google's ReCaptcha, but at the moment it was not possible to verify that your browser is safe. " +
            'Por favor tente novamente, se o problema persistir entre em contato.',
        refresh: 'Error getting recaptcha token. Refresh the page.',
    },
    imap_connection: {
        title: 'Unable to connect to the IMAP server!',
        message: 'Unable to connect to the IMAP server using the data entered in the form. ' +
            'Check the form data and try again.',
    },
    '400': 'Problem with the request, try again.',
    '401': 'Session terminated, log in again.',
    '403': "You don't have permission to perform this action.",
    '404': 'Record not found',
    '419': 'Expired section, refresh the page.',
    '422': 'Fix errors in form fields.',
    '429': 'Many requests within seconds. Please wait a few seconds and try again.',
}
